import { render, staticRenderFns } from "./albumsView.vue?vue&type=template&id=fe8b0ffa&scoped=true"
import script from "./albumsView.vue?vue&type=script&lang=js"
export * from "./albumsView.vue?vue&type=script&lang=js"
import style0 from "./albumsView.vue?vue&type=style&index=0&id=fe8b0ffa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe8b0ffa",
  null
  
)

export default component.exports